import React, { Component, Suspense } from 'react';
import {createRoot} from 'react-dom/client';
import { MapTo, EditableComponent } from '@adobe/aem-react-editable-components';
import * as _ from 'lodash-es';
import ppUtilities from '../ProductPricing/ppUtilities';
import eCart from '../ProductPricing/eCart.js';
import PPdata from '../ProductPricing/data/ProductPricingData.js';
import ppSectionData from '../ProductPricing/data/ppSectionData.js';
import ProductGrouping from '@/features/product/product-card/components/ProductGrouping.js';
import PageLoader from '@/components/shared/PageLoader';
import initSecContext from '../ProductPricing/data/initSecContext.js';
import LocalContext from '../ProductPricing/data/Localization.js';
import ProductPricingDataLayer from '../ProductPricing/data/productPricingDataLayer.js';
import ProductPricingDataLayerAsync from '../ProductPricing/data/productPricingDataLayerAsync';
import { Analytics } from '../../services/analytics/analytics-service';
import { announce } from '../../utils/common/live-announcer';
import { formatStorePrice } from '../../utils/ecommerce/currency';
import Cookies from 'js-cookie';
import VatSwitcher from '@/features/product/product-card/components/VatSwitcher';
import { VAT_BUSS_PRICE, VAT_CONS_PRICE, VAT_EXCLUDED, VAT_INCLUDED, VAT_SHOWING, VAT_VIEW } from '../ProductPricing/data/Localization';
import {EVENTS, ECOMMERCE} from '@/services/analytics/constants';
import {AEM_MAPPED_TYPES} from '@/constants';
import ProductErrorMessage from '@/features/product/components/ProductErrorMessage';
import {showNotification} from '@/features/cart/slices/cart-notification-slice';

const _storeVariables = window.storeVariables || {};

const LoadableCartFlyout = React.lazy(() => import(/* webpackChunkName: "cartFlyout" */ '@/features/cart/components/CartFlyoutContainer'));
const LoadableBuyCard = React.lazy(() => import(/* webpackChunkName: "buyCardComponent" */ '@/features/product/product-card/components/ProductCard'));
const LoadableBundleBuyCard = React.lazy(() => import(/* webpackChunkName: "bundleBuyCardComponent" */ '@/features/product/product-card/components/BundleProductCard'));

const ProductPricingSectionConfig = {
  emptyLabel: 'Product Pricing Section',
  isEmpty: (props) => !props,
};

class ProductPricingSectionBase extends Component {
	constructor(props) {
		super(props);
		this._self = this;
		this.productLoadPromise = new Promise((resolve) => (this.productLoadPromiseResolve = resolve));
		this.analytics = Analytics.getInstance();
		this.prodInfo = props.productInfo ? props.productInfo : { ...props };
		console.info('[cardData ~ allowed: dev, stg v.8.1]: ', this.prodInfo);
		window.storeVariables.storeLabels = window.storeVariables.storeLabels || {};
		window.storeVariables.storeLabels[this.prodInfo.cqPath] = this.prodInfo;

		this.initSecContext = initSecContext.getPropsContext();
		// Due to AEM react plugin which pass all added components to the page as SPA
		// regardless of component being a standalone component. So we are using a global
		// context to manage this issue.
		if (!this.initSecContext.active) {
			this.initSecContext.active = true;
		} else {
			// if component app is alredy active return;
			return;
		}
		this.analytics.setLocalItem('productPromises', [...(this.analytics.getLocalItem('productPromises') || []), this.productLoadPromise]);
		initSecContext.setPropsContext(this.initSecContext);
		this.componentId = this.initSecContext.productId; // ComponentId
		this.btnInfo = {
			verifyBtnLabel: this.prodInfo.verifyBtnLabel,
			verifyTextMssg: this.prodInfo.verifyTextMssg,
			veryfyURL: this.prodInfo.veryfyURL,
			signinBtnLabel: this.prodInfo.signinBtnLabel,
			signinTextMssg: this.prodInfo.signinTextMssg,
			signinURL: this.prodInfo.signinURL,
			scnBtnLabel: this.prodInfo.scnBtnLabel,
			scnTextMssg: this.prodInfo.scnTextMssg,
			scnURL: this.prodInfo.scnURL,
			loginToSeePriceBtnLabel: this.prodInfo.loginToSeePriceBtnLabel,
			loginToSeePriceTextMssg: this.prodInfo.loginToSeePriceTextMssg,
			loginToSeePriceURL: this.prodInfo.loginToSeePriceURL,
		};
		initSecContext.setBtnInfo(this.btnInfo, this.componentId);

		// set the cartURL string to Localization
		this.verificationNeeded = this.initSecContext.verificationNeeded == 'true' ? 'true' : 'false';
		this.verificationType = this.prodInfo.verificationType || null;
		this.prodInfo.cartURL = this.initSecContext.cartURl;
		LocalContext.setLabels(this.prodInfo);
		this.app = this.initSecContext.app;
		this.ProductPricingData = null;
		// check if this is the last section to be processed
		// if it is it will trigger comparison table
		this.isLastSection = this.initSecContext.isLast;
		this.eCartData = {};
		this.isFirstRender = true;
		this.utils = new ppUtilities();
		this.eCart = null;
		this.ctId = this.initSecContext.ctID;
		this.hasRunOnce = 'none'; // comparison table id
		this.prepTableIsNotDone = true; // run callback only once
		this.comparisonActive = false;
		this.comparisonActiveData = {};
		this.lookUpByProductPath = {};
		this.refreshErrorMsg = this.prodInfo.refreshErrorMsg || 'Please come back soon'; // String is just a worst-case backup. Text should be authored and localized
		this.refreshErrorMsgTitle = this.prodInfo.refreshErrorMsgTitle || 'Sorry we did not find information!'; // String is just a worst-case backup. Text should be authored and localized
		this.urlCompareItems = this.getCompareItemsFromUrl();
		this.updateNo = 0; // Remove only for testing.

		// state
		this.state = { error: null };

		// sections
		this.ppDataSec = new ppSectionData();
		this.productsData;
		this.fullApiResponse;
		this.processGeoblockingStatus();

		if (this.initSecContext.isLast && this.props.hasProductPricingCompTable) {
			Promise.all(this.analytics.getLocalItem('productPromises')).then((dataList) => {
				const items = Analytics.toItems(dataList, Analytics.dataType.PRODUCT);
				const tabTitleToTabPanelId = dataList.reduce(
					(map, data) => ({
						...map,
						[data?.tabTitle]: data?.tabPanelId,
					}),
					{}
				);
				const tabPanelIdList = [...new Set(dataList.map((data) => data?.tabPanelId))];
				const activeTabPanelId = tabPanelIdList.find((id) => document.getElementById(id)?.classList.contains('cmp-tabs__tabpanel--active'));
				const inactiveTabPanelIdList = tabPanelIdList.filter((id) => id !== activeTabPanelId);

				inactiveTabPanelIdList.forEach((id) => {
					const elementToObserve = document.getElementById(id);
					const observer = new MutationObserver((mutationList, observer) => {
						const activeRecord = mutationList.find((record) => record.oldValue === 'true' && !record.ariaHidden);
						if (!activeRecord) return;
						const activeTabPanelId = activeRecord.target.id;

						this.analytics.addEvent(EVENTS.PRODUCT_VIEW, {
							items: this.analytics.getLocalItem('items').filter((item) => tabTitleToTabPanelId[item.tabTitle] === activeTabPanelId),
						});
						observer.disconnect();
					});
					observer.observe(elementToObserve, { attributes: true, attributeOldValue: true, attributeFilter: ['aria-hidden'] });
				});

				this.analytics.setLocalItem('items', items);
				this.analytics.addPageInfo({
					pageType: 'Product',
					pageSubType: 'Product-Pricing',
					ecommerce: {
						storeType: ECOMMERCE.OMNI_STORE,
						storeFront: Analytics.toStoreFront(this.productsData.zone),
						distributorNumber: this.productsData.distributorNumber,
					},
				});
				this.analytics.addEvent(EVENTS.PRODUCT_VIEW, {
					items: this.analytics.getLocalItem('items').filter((item) => tabTitleToTabPanelId[item.tabTitle] === activeTabPanelId),
				});
			});
		}

		this.handleProdCompare = this.handleProdCompare.bind(this);
		this.handleQtyMinus = this.handleQtyMinus.bind(this);
		this.handleQtyChange = this.handleQtyChange.bind(this);
		this.handleRemoveErrorMsg = this.handleRemoveErrorMsg.bind(this);
		this.handleQtyPlus = this.handleQtyPlus.bind(this);
		this.handleAddToCart = this.handleAddToCart.bind(this);
		this.handlePriceChange = this.handlePriceChange.bind(this);
		this.handleCartCallIsDone = this.handleCartCallIsDone.bind(this);
		this.handleCancelComparions = this.handleCancelComparions.bind(this);
		this.setComparableProducts = this.setComparableProducts.bind(this);
		this.onItemsAddedToCart = this.onItemsAddedToCart.bind(this);
	}

	processGeoblockingStatus() {
		if (window.storeVariables?.geoblockingStatus === 'loading') {
			const handleGeoblockingStatus = (event) => {
				const status = event.detail.status;
				if (status !== 'enabled' && status !== 'disabled') return;

				this.setProductData();
				document.removeEventListener('geoblocking:status', handleGeoblockingStatus);
			};
			document.addEventListener('geoblocking:status', handleGeoblockingStatus);
		} else {
			this.setProductData();
		}
	}

	async setProductData() {
		try {
			this.productsData = await this.ppDataSec.getCardsData(this.verificationNeeded, this.verificationType, _storeVariables);
		} catch (error) {
			this.productLoadPromiseResolve({});
			let currentError = error.toString();
			this.renderError(currentError);
		}
		if (this.productsData && this.productsData.error) {
			this.renderError(this.productsData.error);
		}
		this.initDataCalls();
		this.productLoadPromiseResolve({
			productPricingData: this.state.data,
			tabTitle: this.initSecContext.tabTitle,
			tabPanelId: this.initSecContext.tabPanelId,
		});
		setTimeout(() => {
			if (this.state.data && this.productsData.zone && this.initSecContext.totalSections && this.props.hasProductPricingCompTable) {
				new ProductPricingDataLayer(this.state.data, this.productsData.zone, this.initSecContext.totalSections);
			} else if (this.state.data && this.productsData.zone && this.initSecContext.totalSections && !this.props.hasProductPricingCompTable) {
				new ProductPricingDataLayerAsync(this.state.data, this.productsData.zone, this.initSecContext.totalSections);
				this.analytics.addPageInfo({
					pageType: 'Product',
					pageSubType: 'Product-Pricing',
					ecommerce: {
						storeType: ECOMMERCE.OMNI_STORE,
						storeFront: Analytics.toStoreFront(this.productsData.zone),
						distributorNumber: this.productsData.distributorNumber,
					},
				});
			} else {
				console.warn('Data, zone, or Product Pricing Card total not available for datalayer.');
			}
		}, 1000);
	}

	componentDidMount() {
		this.hasRunOnce = 'once';

		const vatPriceSelection = Cookies.get('hasVatPriceSelection');
		const hasAllVATLabels = VAT_BUSS_PRICE && VAT_CONS_PRICE && VAT_EXCLUDED && VAT_INCLUDED && VAT_SHOWING && VAT_VIEW;
		if (vatPriceSelection && !hasAllVATLabels) {
			console.error('[ERROR: VAT messages are missing please author labels]');
		} else if (vatPriceSelection && hasAllVATLabels) {
			const vatProcessedHeader = document.querySelector('[data-vat-header]');
			const titleWrapper = document.querySelector('.buy-title-wrapper'); /* class needs to be authored on the title wrapper */
			if (titleWrapper && !vatProcessedHeader) {
				let vatSwitcherContainer = document.createElement('div');
				vatSwitcherContainer.setAttribute('data-vat-header', 'true');
				titleWrapper.appendChild(vatSwitcherContainer);
				const root = createRoot(vatSwitcherContainer);
				root.render(<VatSwitcher />);
			}
		}
	}

	componentDidUpdate() {
		if (this.state?.data != null && this.hasRunOnce == 'once') {
			this.componentRunOnce();
		}

		if (this.comparisonActive) {
			this.comparisonActive = false;
			initSecContext.comparisonTriggered(this.comparisonActiveData, this._self);
		}
	}

	componentRunOnce() {
		// needs to run once but data comes after constructor and componentDidMount;
		this.hasRunOnce = true;
		this.utils.checkWithinTabSys(this.app);
		let hasTabs = this.utils.isWithinTabsSys();
		let activeTab = this.app; // App container if not tabs
		if (hasTabs) {
			this.utils.tabListener();
			activeTab = document.querySelector('.cmp-tabs__tabpanel--active');
		}
		this.utils.handleCardsAnimation(activeTab);

		ppUtilities.anchorTagsToNewTab('.prc__desc--content');

		this.hasRunOnce = 'more_than_once'; // reseting it to original state
		if (this.isFirstRender == true) {
			// important to complete animation on the product price
			this.isFirstRender = false;
			this.setState({ tisFirstRender: false });
		}
	}

	initData(appWrapper) {
		if (!this.productsData) {
			console.error('no products data!!');
			return null;
		}
		this.ProductPricingData = new PPdata(this.productsData, this.ctId, this.componentId);
		let data = this.ProductPricingData.getPPModel();
		// If no product data is passed;
		if (data.error != undefined) {
			this.renderError(data.error);
			return;
		}
		let eCartData = this.ProductPricingData.getECartResponse();
		this.eCart = new eCart(eCartData, this.onItemsAddedToCart);
		if (initSecContext.context.GlobalCar === null) {
			this.eCart = new eCart(eCartData, this.onItemsAddedToCart);
			initSecContext.setGlobalCar(this.eCart);
		} else {
			this.eCart = initSecContext.getGlobalCar();
		}
		return data;
	}

	onItemsAddedToCart(payload) {
		this.initSecContext.store.dispatch(showNotification(payload));
	}

	getCompareItemsFromUrl() {
		let currentURLQuery = window.location.search;
		if (currentURLQuery.includes('&compare') || currentURLQuery.includes('?compare')) {
			return ppUtilities.getURLCompareKeys(currentURLQuery);
		} else {
			return null;
		}
	}

	getProductData(appWrapper) {
		let $script = appWrapper.querySelector('.js-prcApp-data');
		let data = $script.innerText;
		if ($script && (data != null || data.trim().length !== 0)) {
			// make sure string is not empty
			return JSON.parse(data);
		} else {
			return null;
		}
	}

	renderError(error) {
		this.analytics.addEvent(EVENTS.ERROR, {
			errorDesc: `${error?.name}: ${error?.message}`,
		});
		this.setState({ error });
	}
	/* callbacks */

	formatPrice(price) {
		const isWholeNumber = price % 1 === 0;
		const currencyOptions = isWholeNumber ? { maximumFractionDigits: 0 } : undefined;
		return formatStorePrice(price, this.eCart?.sessionData?.metadata?.formattedLocale, this.eCart?.sessionData?.metadata?.currency, currencyOptions);
	}

	handleQtyPlus(activeCardIds) {
		let currState = [...this.state.data];
		const activeCardIdMap = activeCardIds.reduce((map, id) => ({ ...map, [id]: true }), {});
		let data = this.iterateState(currState, (prod) => {
			if (activeCardIdMap[prod.id]) {
				prod.inputError.error = false;
				// update qty:
				const activeProduct = prod.products.find((p) => p.sku === prod.activeSku);
				const multiplier = activeProduct?.qty || 1;
				const newQty = prod.qty + 1 * multiplier;
				if (newQty / multiplier <= 999) {
					prod.qty = newQty;
				} else {
					prod.inputError.error = `${prod.qty} is the max qty allowed for this product`;
				}

				// set subTotal
				let price = this.getProdPrice(prod);
				prod.activePrice = this.getNewSubTotal(price, prod.qty);
				announce(Granite.I18n.get('ProductQuantityChange', [prod.title, this.formatPrice(prod.activePrice), prod.qty]));
			}
			return prod;
		});

		this.setState({ data });
	}

	handleQtyMinus(activeCardIds) {
		let currState = [...this.state.data];
		const activeCardIdMap = activeCardIds.reduce((map, id) => ({ ...map, [id]: true }), {});
		let data = this.iterateState(currState, (item) => {
			if (activeCardIdMap[item.id]) {
				const activeProduct = item.products.find((p) => p.sku === item.activeSku);
				const multiplier = activeProduct?.qty || 1;
				const newQty = item.qty - 1 * multiplier;
				if (newQty / multiplier >= 0) {
					item.qty = newQty;
				} else {
					item.qty = 0;
				}
				// set subTotal
				let price = this.getProdPrice(item);
				item.activePrice = this.getNewSubTotal(price, item.qty);
				announce(Granite.I18n.get('ProductQuantityChange', [item.title, this.formatPrice(item.activePrice), item.qty]));
			}
			return item;
		});
		this.setState({ data });
	}

	handleQtyChange(activeCardIds, val) {
		let currState = [...this.state.data];
		const activeCardIdMap = activeCardIds.reduce((map, id) => ({ ...map, [id]: true }), {});
		let data = this.iterateState(currState, (prod) => {
			if (activeCardIdMap[prod.id]) {
				const activeProduct = prod.products.find((p) => p.sku === prod.activeSku);
				const multiplier = activeProduct?.qty || 1;
				const newQty = val * multiplier;
				if (val >= 0 && val <= 999) {
					prod.qty = newQty;
				} else if (val <= 0) {
					prod.qty = 0;
				}
				// set subTotal
				let price = this.getProdPrice(prod);
				prod.activePrice = this.getNewSubTotal(price, prod.qty);
				announce(Granite.I18n.get('ProductQuantityChange', [prod.title, this.formatPrice(prod.activePrice), prod.qty]));
			}
			return prod;
		});
		this.setState({ data });
	}

	handlePriceChange(activeCardIds, sku) {
		let currState = [...this.state.data];
		const activeCardIdMap = activeCardIds.reduce((map, id) => ({ ...map, [id]: true }), {});
		let data = this.iterateState(currState, (prod) => {
			if (activeCardIdMap[prod.id]) {
				prod.activeSku = sku;
				let currOpt = prod.products.filter((cta) => cta.sku === sku);
				if (currOpt[0].amount) {
					prod.activePrice = this.getNewSubTotal(currOpt[0].amount, prod.qty);
				}
				prod.activeTag = currOpt[0].tag;
			}
			return prod;
		});
		this.setState({ data });
	}

	handleAddToCart(activeCardIds) {
		if (this.state.carCallActive) {
			return;
		}

		// Create clone of an data, flatten it, and then filter based on activeCardIds
		const dataClone = [...this.state.data];
		const activeCardIdMap = activeCardIds.reduce((map, id) => ({ ...map, [id]: true }), {});
		let selectedProducts = dataClone.flat();
		if (activeCardIds.length) {
			selectedProducts = selectedProducts.filter((prod) => activeCardIdMap[prod.id]);
		}

		// Update cartQty for each selected product
		selectedProducts.forEach((prod) => {
			prod.cartQty.update = true;
			prod.cartQty.qty = prod.cartQty.qty + prod.qty;
		});

		// Add selected products to cart
		this.eCart.addToCart(selectedProducts, this, 'handleCartCallIsDone');

		// Update state
		this.setState({
			data: this.mergeProductData(dataClone, selectedProducts),
			carCallActive: true,
		});
	}

	mergeProductData(mainSource, ...sources) {
		if (!sources.length) return [...mainSource];

		const source = sources.shift();
		const productIdMap = source.reduce((map, prod) => ({ ...map, [prod.id]: prod }), {});

		const newMainSource = mainSource.map((prod) => {
			if (productIdMap[prod.id]) {
				return { ...productIdMap[prod.id] };
			} else if (Array.isArray(prod)) {
				return this.mergeProductData(prod, source);
			}
			return prod;
		});

		return this.mergeProductData(newMainSource, ...sources);
	}

	iterateState(currState, operation) {
		let data = currState.map((prod) => {
			if (prod.id) {
				return operation(prod);
			} else if (Array.isArray(prod)) {
				let prodArr = prod.map((subProd) => {
					return operation(subProd);
				});
				return prodArr;
			}
		});
		return data;
	}

	getNewSubTotal(price, qty) {
		let subTotal = qty * numeric(price);
		return subTotal;

		function numeric(num) {
			return Number.parseFloat(num).toFixed(2);
		}
	}

	getProdPrice(prod) {
		if (prod.products.length == 1) {
			return prod.products[0].amount;
		}
		let actCta = prod.products.filter((cta) => cta.sku == prod.activeSku);
		return actCta[0].amount;
	}

	hasCompareProducts() {
		let currState = this.getComparisonNavData();
		let hasActiveCompareProd = false;

		currState.forEach((prod) => {
			if (prod.isSelected) {
				hasActiveCompareProd = true;
			}
		});

		return hasActiveCompareProd;
	}

	getComparisonNavData() {
		let currData = this.state.data;
		let flatProdArr = [];
		currData.forEach((item) => {
			const isBundle = Array.isArray(item) && item.length && this.productsData.config.isBundleByPath[item[0].productPath];
			if (isBundle) {
				const amount = item.reduce((acc, subItem) => acc + subItem.products?.[0].amount * (subItem.products?.[0].qty || 1), 0);
				const bundleItem = {
					...item[0],
					products: [
						{
							tag: item[0].products?.[0].tag,
							displayPrice: this.formatPrice(amount),
						},
					],
				};
				flatProdArr = [...flatProdArr, bundleItem];
			} else if (Array.isArray(item) && !isBundle) {
				flatProdArr = [...flatProdArr, ...item];
			} else {
				flatProdArr = [...flatProdArr, item];
			}
		});
		let compNavData = this.iterateState(flatProdArr, (prod) => {
			if (!prod.products.length) {
				return {};
			}
			let activeProd = prod.products.filter((item) => prod.activeTag == item.tag)[0];
			let license = { displayPrice: activeProd.displayPrice, tag: activeProd.tag };
			return {
				title: prod.title,
				id: prod.id,
				activeSku: prod.activeSku,
				license: license,
				isSelected: prod.compare,
				icon: prod.icon,
			};
		});
		return compNavData;
	}

	handleProdCompare(activeCardIds) {
		let currState = [...this.state.data];
		const activeCardIdMap = activeCardIds.reduce((map, id) => ({ ...map, [id]: true }), {});

		let data = this.iterateState(currState, (prod) => {
			if (activeCardIdMap[prod.id]) {
				prod.compare = !prod.compare;
			}
			return prod;
		});
		this.comparisonActive = true;
		this.setState({ data });
	}

	getNoItemsBeingCompared() {
		let currState = this.state.data;
		let comperItems = 0;
		this.iterateState(currState, (prod) => {
			if (prod.compare == true) {
				comperItems += 1;
			}
			return prod;
		});

		return comperItems;
	}

	handleCancelComparions() {
		let currState = this.state.data;
		let data = this.iterateState(currState, (prod) => {
			prod.compare = false;
			return prod;
		});
		this.comparisonActive = true;
		this.setState({ data });
	}

	handleCartCallIsDone() {
		let currData = this.state.data;
		// reset current update val
		let data = currData.map((prod) => {
			if (prod.id) {
				prod.cartQty.update = false;
				return prod;
			} else if (Array.isArray(prod)) {
				// handle grouped products
				let newProdArr = prod.map((supProd) => {
					supProd.cartQty.update = false;
					return supProd;
				});
				return newProdArr;
			}
		});
		this.setState({ data: data, carCallActive: false });
	}

	handleRemoveErrorMsg(activeCardIds) {
		let currState = [...this.state.data];
		const activeCardIdMap = activeCardIds.reduce((map, id) => ({ ...map, [id]: true }), {});
		let data = this.iterateState(currState, (prod) => {
			if (activeCardIdMap[prod.id]) {
				prod.inputError.error = false;
			}
			return prod;
		});
		this.setState({ data });
	}

	setComparableProducts(compProducts) {
		// after context knows the products that are comparable
		// we are updating the products to reflext is they are comparable
		let currState = this.state.data;

		let data = this.iterateState(currState, (prod) => {
			let processedProd = prod;
			processedProd.isComparable = false;
			compProducts.forEach((cprod) => {
				if (prod.id == cprod.id) {
					processedProd.isComparable = true;
				}
			});
			return processedProd;
		});
		this.setState({ data });
	}

	initDataCalls() {
		let data = this.initData(this.initSecContext.appWrapper);
		this.lookUpByProductPath = this.ProductPricingData.getPathIdLookUp(data);
		this.setState({
			data,
			carCallActive: false,
		});
	}

	handleActiveComparisonToURL() {
		let currentURLQuery = window.location.search;
		if (currentURLQuery.includes('&compare') || currentURLQuery.includes('?compare')) {
			currentURLQuery = ppUtilities.removeCompareQuery(currentURLQuery);
		}
		let compareProdArr = this.getComparisonNavData();
		let hashSelect = '';
		compareProdArr.forEach((prod) => {
			if (prod.isSelected) {
				hashSelect = hashSelect.length ? `${hashSelect},${prod.activeSku}` : `${prod.activeSku}`;
			}
		});

		if (hashSelect.length) {
			let dateQuery = currentURLQuery == '' ? `?compare=${hashSelect}` : `${currentURLQuery}&compare=${hashSelect}`;
			history.pushState(null, null, `${dateQuery}`);
			// this.handleHashChange(selectedDate);
		} else {
			history.pushState(null, null, `${currentURLQuery}`);
		}
	}

	render() {
		if (this.state === null) {
			return null;
		}
		//TODO: remove this code after QA is done.
		let hasTestErrorMssg = location.hash.indexOf('testErrorMsg') > -1 ? true : false;
		if (this.state.error !== null || hasTestErrorMssg) {
			return (
				<div className="grid-container">
					<section className="column-12 pre-6 leader-3 trailer-2">
						<ProductErrorMessage title={this.refreshErrorMsgTitle} message={this.refreshErrorMsg} />
					</section>
				</div>
			);
		}
		let hasComparisonData = this.initSecContext.hasCT;
		// let hasComparisonData = 'no_data_back';
		// Handle no product data from aem
		let data = this.state.data;
		if (data == null || _.isEmpty(data)) {
			return <PageLoader />;
		}
		let cartCallActive = this.state.carCallActive;
		let Cards = data.map((product, indx) => {
			const isBundle = Array.isArray(product) && product.length && this.productsData.config.isBundleByPath[product[0].productPath];
			// Check if product is a single product, group of products, or a bundle
			if (product.id && !isBundle) {
				product.cartCallActive = cartCallActive;
				const isOpen = this.productsData.config.isOpenByPath[product.productPath];
				let isComparable = product.isComparable || false;
				this.updateNo = this.updateNo + 1;
				return (
					<Suspense fallback={<></>}>
						<LoadableBuyCard
							errorType={this.productsData.errorType}
							handleProdCompare={this.handleProdCompare}
							handleQtyMinus={this.handleQtyMinus}
							handleQtyChange={this.handleQtyChange}
							handleRemoveErrorMsg={this.handleRemoveErrorMsg}
							handleQtyPlus={this.handleQtyPlus}
							handleAddToCart={this.handleAddToCart}
							handlePriceChange={this.handlePriceChange}
							hasComparisonData={isComparable}
							currSecKey={this.productsData.currSec}
							updateNo={this.updateNo}
							initOpen={isOpen}
							key={indx}
							product={product}
							price={false}
							kind={'single'}
							hasAnimation={this.isFirstRender}
							formattedLocale={this.eCart?.sessionData?.metadata?.formattedLocale}
							currency={this.eCart?.sessionData?.metadata?.currency}
							styleIds={this.props["cq:styleIds"]}
						/>
					</Suspense>
				);
			} else if (Array.isArray(product) && product.length && !isBundle) {
				product.forEach((childProd) => {
					if (childProd) childProd.cartCallActive = cartCallActive;
				});
				return (
					<ProductGrouping
						handleProdCompare={this.handleProdCompare}
						handleQtyMinus={this.handleQtyMinus}
						handleQtyChange={this.handleQtyChange}
						handleRemoveErrorMsg={this.handleRemoveErrorMsg}
						handleQtyPlus={this.handleQtyPlus}
						handleAddToCart={this.handleAddToCart}
						handlePriceChange={this.handlePriceChange}
						hasComparisonData={hasComparisonData}
						currSecKey={this.productsData.currSec}
						key={indx}
						cards={product}
						hasAnimation={this.isFirstRender}
						formattedLocale={this.eCart?.sessionData?.metadata?.formattedLocale}
						currency={this.eCart?.sessionData?.metadata?.currency}
					/>
				);
			} else if (Array.isArray(product) && product.length && isBundle) {
				product.forEach((childProd) => {
					if (childProd) childProd.cartCallActive = cartCallActive;
				});
				this.updateNo = this.updateNo + 1;
				const isOpen = this.productsData.config.isOpenByPath[product[0].productPath];
				const isComparable = product[0].isComparable || false;
				return (
					<Suspense fallback={<></>}>
						<LoadableBundleBuyCard
							errorType={this.productsData.errorType}
							handleProdCompare={this.handleProdCompare}
							handleQtyMinus={this.handleQtyMinus}
							handleQtyChange={this.handleQtyChange}
							handleRemoveErrorMsg={this.handleRemoveErrorMsg}
							handleQtyPlus={this.handleQtyPlus}
							handleAddToCart={this.handleAddToCart}
							handlePriceChange={this.handlePriceChange}
							hasComparisonData={isComparable}
							currSecKey={this.productsData.currSec}
							updateNo={this.updateNo}
							initOpen={isOpen}
							key={indx}
							products={product}
							price={false}
							kind={'bundle'}
							hasAnimation={this.isFirstRender}
							formattedLocale={this.eCart?.sessionData?.metadata?.formattedLocale}
							currency={this.eCart?.sessionData?.metadata?.currency}
							styleIds={this.props["cq:styleIds"]}
						/>
					</Suspense>
				);
			}
		});
		let compTableActive = this.hasCompareProducts();
		let comparableProducts = this.getComparisonNavData();

		// if data exist
		// this.handleActiveComparisonToURL(); // will be refactored when we add the comparsion table to the url

		if (hasComparisonData && this.prepTableIsNotDone) {
			let tableUpdate = {
				comparisonTableId: this.ctId,
				compTableActive: compTableActive,
				comparableProducts: comparableProducts,
				handleComparisonSelection: this.handleProdCompare,
				lookUpByProductPath: this.lookUpByProductPath,
				handleCancelComparions: this.handleCancelComparions,
				order: this.initSecContext.order, // order of sections and cards
			};

			this.prepTableIsNotDone = false;
			initSecContext.prepTableUpdate(tableUpdate, this._self);
		}

		if (hasComparisonData && this.comparisonActive) {
			this.comparisonActiveData = {
				compTableActive: compTableActive,
				comparableProducts: comparableProducts,
				hasComparisonData: hasComparisonData,
			};
		}
		let updateNo = this.updateNo > 0 ? `update-${this.updateNo}` : '';
		return (
			<React.Fragment>
				<div className="grid-container padding-leader-2 prc_container">
					<div className={`background-cards pre-1 post-1 ${updateNo}`}>{Cards}</div>
				</div>
				{this.isLastSection &&
					this.props.hasProductPricingCompTable && ( // we just need to set up one flyout per page
						<Suspense fallback={<></>}>
						<LoadableCartFlyout />
						</Suspense>
					)}
				{!this.props.hasProductPricingCompTable && this.loadFlyout()}
			</React.Fragment>
		);
	}

	loadFlyout() {
		// Render flyout only once per page
		this.flyoutId = this.flyoutId || document.querySelector('.flyout-component-wrapper')?.id;
		if (this.flyoutId && this.flyoutId !== `${this.componentId}-flyout-component-wrapper`) return null;

		return (
			<div id={`${this.componentId}-flyout-component-wrapper`} className="flyout-component-wrapper">
				<Suspense fallback={<></>}>
					<LoadableCartFlyout />
				</Suspense>
			</div>
		);
	}
}

const ProductPricingSection = (props) => {
  return (
    <EditableComponent config={ProductPricingSectionConfig} {...props}>
      <ProductPricingSectionBase {...props} />
    </EditableComponent>
  );
};
MapTo(AEM_MAPPED_TYPES.PRODUCT_PRICING_SECTION)(ProductPricingSection);

export default ProductPricingSection;
